// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"97b134a1","239":"2fad38ae","453":"d397b8e2","732":"5c5a5342","977":"be927c46"}[chunkId] + ".chunk.js";
};